/**
 * Product Watches View
 */
class ProductWatchesView {

	constructor(presenter, sectionId) {
		
		this.parent = $("#shopify-section-" + sectionId);
		this.form = this.parent.find("form").first();
		this.submit = this.form.find("button").first();		
		this.productSlideNumber = $("#mon-product-slide-number");
		this.zoomInSlideNumber = $("#mon-product-zoom-in-slide-number");
		this.wishlistAdd = this.parent.find(".mon-wishlist-add");
		this.recommendations = $("#mon-recommendations");
		this.recommendationTemplate = $("#mon-recommendation-template");
		this.recommendationsRow = $(".mon-recommendations-row").first();
		this.presenter = presenter

		/*
		 * Listeners
		 */

		// listen for form submission
		this.form.on("submit", $.proxy(function(event) {
			// we handle the form submission via ajax, so cancel the submit event
			event.preventDefault();
			event.stopPropagation();
			// there is no need for validation
			const formData = new FormData(this.form.get(0));
			this.submit.prop("disabled", true);
			this.presenter.updateCart(formData);
		}, this));

		// listen for add to wishlist events
		this.wishlistAdd.on("click", $.proxy(function(event) {
			
			// get the handle from the event target, and request it is added to the wishlist
			const handle = $(event.currentTarget).attr("data-product-handle");
			if (handle === undefined || handle == null) { return; }
			this.presenter.wishlistAdd(handle);

		}, this));

		/*
		 * Initialisation
		 */

		const productSwiper = new Swiper("#mon-product-swiper", {
			navigation: {
				prevEl: "#mon-product-swiper-prev",
				nextEl: "#mon-product-swiper-next"
			},
			loop: true,
			spaceBetween: 8
		});
		productSwiper.on("slideChange", $.proxy(function() {
			// compute the slide number then update the user interface
			const number = productSwiper.realIndex + 1;
			this.productSlideNumber.text(number);
		}, this));

		const zoomInSwiper = new Swiper("#mon-product-zoom-in-swiper", {
			navigation: {
				prevEl: "#mon-product-zoom-in-swiper-prev",
				nextEl: "#mon-product-zoom-in-swiper-next"
			},
			loop: true,
			spaceBetween: 8
		});
		zoomInSwiper.on("slideChange", $.proxy(function() {
			// compute the slide number then update the user interface
			const number = zoomInSwiper.realIndex + 1;
			this.zoomInSlideNumber.text(number);
		}, this));

		new Swiper("#mon-recommendations-swiper", {
			slidesPerView: 2,
			slidesPerGroup: 2,
			breakpoints: {
				// > 540px is the bootstrap container width threshold before the md breakpoint starts
				541: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				// > 768px is the bootstrap container width threshold before the lg breakpoint starts
				769: {
					slidesPerView: 4,
					slidesPerGroup: 4
				}
			},
			navigation: {
				prevEl: "#mon-recommendations-swiper-prev",
				nextEl: "#mon-recommendations-swiper-next"
			},
			spaceBetween: 8
		});

		new Swiper("#mon-brand-swiper", {
			navigation: {
				prevEl: "#mon-brand-swiper-prev",
				nextEl: "#mon-brand-swiper-next"
			},
			spaceBetween: 8
		});

	}

	/*
	 * Actions
	 */

	resetForm() {
		// reset the form
		this.form.trigger("reset");
		this.submit.prop("disabled", false);
	}

	/*
	 * Getters and Setters
	 */

	setRelatedProducts(html) {

		// iterate over the product recommendations in the retrieved html
		var data = false;
		$(html).find("div.mon-products > div").each($.proxy(function(_index, element) {

			// clone the recommendation template and append this recommendation to it
			const template = this.recommendationTemplate.clone();
			template.removeAttr("id");
			template.removeClass("d-none");
			template.append($(element));

			// add the template to the recommendations row
			this.recommendationsRow.append(template);

			data = true;

		}, this));

		// if we have loaded data, show the recommendations
		if (data === true) { this.recommendations.removeClass("d-none"); }

	}

	setLocalStorageAvailable() {
		this.wishlistAdd.removeClass("d-none");
	}

	setWishlistProductHandles(wishlistProductHandles) {
		// get the handle and see if it is in the list of wishlist product handles
		const handle = this.wishlistAdd.attr("data-product-handle");
		if (wishlistProductHandles.includes(handle)) {
			// we make the filled icon always visible by removing its transition class
			this.wishlistAdd.find("i.mon-icon-transition-top").removeClass("mon-icon-transition-top");
		}
	}

}